import React, { useState } from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { Button } from '../../../../ui';
import { TextInput } from '../../../../ui/input/text_input/text_input';

type CreateUnitModalProps = {
  addUnit: (unitName: string) => void;
};

export const CreateUnitModal = ({ addUnit }: CreateUnitModalProps) => {
  const [unitName, setUnitName] = useState<string>('');
  return (
    <Stack spacing={2.5} sx={{ my: 1.5 }}>
      <TextInput
        name='unitName'
        value={unitName}
        type='text'
        label='Unit Name'
        onChange={(event) => setUnitName(event.target.value)}
      />
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          onClick={() => addUnit(unitName)}
          variant='primary'
          label='Add New Unit'
          disabled={unitName.length === 0}
        />
      </Box>
    </Stack>
  );
};

